import { FC, useState } from 'react';

import { Logs } from '../types';
import LogsList from './LogsList';
import ExtraLogs from './ExtraLogs';
import './styles.scss';

type LogsProps = {
  logCount: number;
  logs: Logs;
};

/**
 *
 * Component that display List of logs  that are currently using this parser.
 * Depending on the quantity of logs, they can be hidden or shown
 *
 * @param {Array} logs        set of logs that are using this parser
 * @param {number} logCount   number of logs that are using this parser
 */
const LogsView: FC<LogsProps> = ({ logs, logCount }: LogsProps) => {
  const firstPart: Logs = logs.length > 2 ? logs.slice(0, 2) : logs;
  const secondPart: Logs = logs.length > 2 ? logs.slice(2) : [];
  const [extraLogsIsShown, setExtraLogsIsShown] = useState<boolean>(false);
  return (
    <div className="LogsView">
      <LogsList logs={firstPart} />
      {secondPart.length > 0 && (
        <>
          {extraLogsIsShown && (
            <>
              <LogsList logs={secondPart} />
            </>
          )}
          <ExtraLogs
            extraLogsIsShown={extraLogsIsShown}
            setExtraLogsIsShown={setExtraLogsIsShown}
            logCount={logCount}
          />
        </>
      )}
    </div>
  );
};
export default LogsView;
